/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import autoBind from 'react-autobind'

export default class FixedPanel extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)

    this.widths = this.getPanelsWidth(this.props.ratio)
  }

  componentDidMount () {
    this.widths = this.getPanelsWidth(this.props.ratio)
  }

  componentDidUpdate (prevProps) {
    if (this.props.ratio !== prevProps.ratio) {
      this.widths = this.getPanelsWidth(prevProps.ratio)
    }
  }

  getPanelsWidth (ratio) {
    const sizes = ratio.split(':')
    const size0 = parseInt(sizes[0], 10)
    const size1 = parseInt(sizes[1], 10)
    const panelsTotal = size0 + size1

    return {
      panels: [
        (100 / panelsTotal * size0).toFixed(3),
        (100 / panelsTotal * size1).toFixed(3)
      ]
    }
  }

  render () {
    return (
      <div
        className='FixedPanel'
        style={{
          display: 'flex',
          position: 'relative'
        }}
      >
        {
          React.Children.map(this.props.children, (child, key) => (
            React.cloneElement(
              child,
              {...child.props, width: this.widths.panels[(key % 2)], key: key}
            )
          ))
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/generic/panels/FixedPanel.js